<template>
    <div>
        <div class="form-group">
            <label for="type">Soort uren <small class="text-danger">*</small></label>
            <select v-model="type" class="form-control custom-select" id="type" name="type">
                <option value="worked_time">Gewerkte uren</option>
                <option value="extra_hours">Gewerkte overuren</option>
                <option value="time_for_time">Tijd voor tijd overuren</option>
            </select>
        </div>

        <div class="form-group">
            <label for="start_date">Startdatum en tijd <small class="text-danger">*</small></label>
            <small ref="date_info" class="text-danger block">{{ date_info }}</small>
            <input v-model="start_date" @input="change_date_info()" class="form-control date-time-picker" v-bind:class="{'is-invalid' : this.errors && this.errors.start_date}" type="text" id="start_date" name="start_date">
            <small v-if="this.errors && this.errors.start_date" class="text-danger">{{this.errors.start_date[0]}}</small>
        </div>

        <template v-if="type === 'worked_time'">
            <div class="form-group">
                <label for="hours">Gewerkte uren <small class="text-danger">*</small></label>
                <input v-model="hours" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.hours}" type="text" id="hours" name="hours">
                <small v-if="this.errors && this.errors.hours" class="text-danger">{{this.errors.hours[0]}}</small>
            </div>

            <div class="form-group">
                <label for="break_minutes">Onbetaalde pauze in minuten <small class="text-danger">*</small></label>
                <input v-model="break_minutes" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.break_minutes}" type="text" id="break_minutes" name="break_minutes">
                <small v-if="this.errors && this.errors.break_minutes" class="text-danger">{{this.errors.break_minutes[0]}}</small>
            </div>
        </template>

        <template v-if="type === 'time_for_time'">
            <div class="form-group">
                <label for="overwork_minutes">Tijd voor tijd in minuten <small class="text-danger">*</small></label>
                <input v-model="overwork_minutes" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.overwork_minutes}" type="text" id="overwork_minutes" name="overwork_minutes">
                <small v-if="this.errors && this.errors.overwork_minutes" class="text-danger">{{this.errors.overwork_minutes[0]}}</small>
            </div>
        </template>

        <template v-else="">
            <div class="form-group">
                <label for="overwork_minutes">Overgewerkte tijd in minuten <small class="text-danger">*</small></label>
                <input v-model="overwork_minutes" class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors.overwork_minutes}" type="text" id="overwork_minutes" name="overwork_minutes">
                <small v-if="this.errors && this.errors.overwork_minutes" class="text-danger">{{this.errors.overwork_minutes[0]}}</small>
            </div>
        </template>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                type: 'worked_time',
                start_date: '',
                hours: '0',
                break_minutes: '0',
                overwork_minutes: '0',
                date_info: ''
            }
        },
        props: {
            errors: {},
            old: {},
        },
        mounted() {
            if(Object.keys(this.old).length > 0)
            {
                this.type = this.old.type;
                this.start_date = this.old.start_date;
                this.change_date_info();
                this.hours = this.old.hours ? this.old.hours : '0';
                this.break_minutes = this.old.break_minutes ? this.old.break_minutes : '0';
                this.overwork_minutes = this.old.overwork_minutes ? this.old.overwork_minutes : '0';
            }
            else
            {
                let start_date_default = new Date();
                start_date_default.setHours(8);
                start_date_default.setMinutes(0);
                start_date_default.setSeconds(0);

                let day = this.set_number_for_date(start_date_default.getDate());
                let month = this.set_number_for_date((start_date_default.getMonth() + 1));
                let hours = this.set_number_for_date(start_date_default.getHours());
                let minutes = this.set_number_for_date(start_date_default.getMinutes());

                this.start_date = day + '-' + month + '-' + start_date_default.getFullYear() + ' / ' + hours + ':' + minutes;
            }
        },
        methods: {
            set_number_for_date: function(number) {
                return number < 10 ? '0' + number : number;
            },
            change_date_info: function () {
                let current_date = new Date();
                if(current_date.getFullYear() < this.start_date.substring(6, 10))
                {
                    this.$refs['date_info'].classList.add('mb-2');
                    this.date_info = 'Je boekt nu uren voor een jaar dat na het huidige jaar valt. Houd er rekening mee dat deze pas vanaf het geselecteerde jaar gaan meetellen voor de opbouw van je verlof.'
                }
                else
                {
                    this.$refs['date_info'].classList.remove('mb-2');
                    this.date_info = '';
                }
            }
        }
    }
</script>
